import { useState, useEffect } from 'react';
export const breakpoints = {
  // Mobile devices (phones)
  mobile: {
    min: 0,
    max: 767,
    name: 'mobile'
  },
  
  // Tablet devices
  tablet: {
    min: 768,
    max: 1023,
    name: 'tablet'
  },
  
  // Desktop devices
  desktop: {
    min: 1024,
    max: 1439,
    name: 'desktop'
  },
  
  // Large desktop devices
  largeDesktop: {
    min: 1440,
    max: Infinity,
    name: 'largeDesktop'
  }
};

// Media query helpers
export const mediaQueries = {
  mobile: `@media (max-width: ${breakpoints.mobile.max}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet.min}px) and (max-width: ${breakpoints.tablet.max}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop.min}px)`,
  largeDesktop: `@media (min-width: ${breakpoints.largeDesktop.min}px)`,
  
  // Range queries
  mobileAndTablet: `@media (max-width: ${breakpoints.tablet.max}px)`,
  tabletAndDesktop: `@media (min-width: ${breakpoints.tablet.min}px)`,
  desktopAndUp: `@media (min-width: ${breakpoints.desktop.min}px)`
};

// Hook for responsive detection
export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState('desktop');
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      
      if (width <= breakpoints.mobile.max) {
        setScreenSize('mobile');
      } else if (width <= breakpoints.tablet.max) {
        setScreenSize('tablet');
      } else if (width <= breakpoints.desktop.max) {
        setScreenSize('desktop');
      } else {
        setScreenSize('largeDesktop');
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return {
    screenSize,
    isMobile: screenSize === 'mobile',
    isTablet: screenSize === 'tablet',
    isDesktop: screenSize === 'desktop',
    isLargeDesktop: screenSize === 'largeDesktop',
    isMobileOrTablet: screenSize === 'mobile' || screenSize === 'tablet',
    isDesktopOrUp: screenSize === 'desktop' || screenSize === 'largeDesktop'
  };
};
